<!-- Runmode:A1Q用のコンポーネント -->
<template>
  <div class="a1q">
    <PinchInImg v-show="showPinchIn"/>
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID">

        <div class="toparea-play">
          <div class="eleAni flexcenter hide">
            <template v-if="isSelect">
              <div v-for="(answer, index) in answersTextList" class="item flexcenter hv" v-show="showSelectAnswer" :key="index">
                <div class="input bg-white" @click="clickAnswer(answer, index)"><span v-html="getPopupTextElem(answer)"></span></div>
                <button class="icon-voice" @click="audioPlay(answersList[index].sounds[0])"></button>
              </div>
            </template>
            <template v-else>
              <div v-for="(answer, index) in answersTextList" class="item flexcenter hv" v-show="showSelectAnswer" :key="index">
                <div class="input bg-white" :id="isAniTarget[index]"><span v-html="getPopupTextElem(answer)"></span></div>
                <button class="icon-voice" @click="audioPlay(answersList[index].sounds[0])"></button>
              </div>
            </template>
            <div v-if="isScrollIconVisible" class="icon-scroll" />
          </div>
        </div>

        <template v-if="isEnvironmentPc()">
          <div class="cards-container active-type2">
            <div class="card-inner card-voice" v-for="(templateType, index) in templateTypes" :class="templateType" :key="index">
              <div class="item" v-for="item in actGroupIndexList[index]" :key="item"
                    :class="{ type1: isChallenge(pathstep.acts[item]) && !showText[item], active: isActive[item] }"
                    :style="{ cursor: cursorTypes[item] }">
                <A1Qact :act="pathstep.acts[item]" :showText="showText[item]" :showResult="showResult[item]"
                        :isCorrect="isCorrect" :isInCorrect="isInCorrect" :index="item" :isAnswerTarget="isAnswerTarget[item]"
                        :isAnimate="isAnimate" @childSetTarget="childSetTarget" @animateEnd="animateEnd"/>
              </div>
            </div>
          <!-- /cards-container -->
          </div>
        </template>
        <template v-else>
          <div class="cards-container active-type2 swiper-container swiper-container1">
            <div class="swiper-wrapper">
              <div class="card-inner card-voice swiper-slide" v-for="(templateType, index) in templateTypes" :class="templateType" :key="index">
                <div class="swiper-container swiper-container2">
                  <div class="swiper-wrapper">
                    <div class="item swiper-slide" v-for="item in actGroupIndexList[index]" :key="item"
                          :class="{ type1: isChallenge(pathstep.acts[item]) && !showText[item], active: isActive[item] }"
                          :style="{ cursor: cursorTypes[item] }">
                      <A1Qact :act="pathstep.acts[item]" :showText="showText[item]" :showResult="showResult[item]"
                              :isCorrect="isCorrect" :isInCorrect="isInCorrect" :index="item" :isAnswerTarget="isAnswerTarget[item]"
                              :isAnimate="isAnimate" @childSetTarget="childSetTarget" @animateEnd="animateEnd"
                              @onTouchStart="onTouchStart" @onTouchEnd="onTouchEnd"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      <!-- /inner -->
      </div>
    <!-- /page-content -->
    </div>
  <!-- /a1_q01 -->
  </div>
</template>

<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import jquery from "jquery";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

// コンポーネント
import A1Qact from "./A1Qact";
// 画像拡大モーダルコンポーネント
import PinchInImg from "./PinchInImg";

export default {
  name: "A1Q",
  props: {
    pathstep: Object,
    isScrollIconVisible: Boolean
  },
  mixins: [
    common,
    runmode,
    audio
  ],
  data() {
    return {
      items: [],
      // 出題対象のactData
      currentData: null,
      // 出題済みの問題をまとめたindex配列
      currentIndex: [],
      // 正解済みactのindex配列
      correctIndex: [],
      // actのグループごとの配列
      actGroupIndexList: [],
      // 解答用のactの配列
      answersList: [],
      // 出題中のテキストの配列（英テキスト／日テキスト）
      answersTextList: [],
      // 回答選択欄表示フラグ
      showSelectAnswer: false,
      // 正解／不正解を判断するフラグ（storeコミット用）
      ActState: true,
      // 正解したか否かを判断するフラグ
      isCorrect: false,
      // 不正解したか否かを判断するフラグ
      isInCorrect: false,
      // 正解／不正解の結果を表示するactを判断するためのBooleanの配列
      showResult: [],
      // テキスト表示するactを判断するためのBooleanの配列
      showText: [],
      // 正解時アニメーション対象を判断するための配列
      isAniTarget: [],
      // 出題時アニメーション対象のactを判断するためのBooleanの配列
      isAnswerTarget: [],
      // 正解時アニメーション実行するかを判断するフラグ
      isAnimate: false,
      // テキスト選択可能かどうかを判断するフラグ
      isSelect: false,
      // 出題中のactを判断するフラグ
      isActive: [],
      // スコア表示から戻る際に同じ問題からスタートするかを判断するフラグ
      isRestart: false,
      // 画像選択時のマウスカーソルの種類を判断するための配列
      cursorTypes: [],
      // 全問正解時のタイマー
      allCorrectTimer: null,
      // sliderInitしたかを判定するフラグ
      isSliderInit: false,
      // タッチイベント長押しタイマー
      touchTimer: null
    };
  },
  computed: {
    templateTypes: function() {
      // テンプレートクラス切り替え
      return this.getTemplateTypes();
    }
  },
  components: {
    A1Qact,
    PinchInImg
  },
  methods: {
    /**
     * 初期化処理
     */
    init: function() {
      this.log("A1Q start init");

      const self = this;

      this.items = this.getItems();
      this.setGroupIndexList(this.items).then(function() {
        // スマホの場合は、sliderを初期化
        if (!self.isEnvironmentPc()) {
          // 既にslider初期化済みの場合は、初期化しない
          if (!self.isSliderInit) {
            self.sliderInit();
            self.isSliderInit = true;
          }
        }
      });
      this.setCursorTypes();
    },
    /**
     * レイアウトに合わせたindex配列を生成する
     */
    setGroupIndexList: function(items) {
      this.log("A1Q start setGroupIndexList");

      const self = this;

      return new Promise(function(resolve, reject) {
        if (self.pathstep.groupNum == 0) {
          // グループなしの場合
          switch (items.length) {
            case 3:
              var singleItems = [];
              for (var i = 0; i < items.length; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              break;
            case 4:
              var singleItems = [];
              for (var i = 0; i < 2; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              singleItems = [];
              for (var i = 2; i < 4; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              break;
            case 5:
              var singleItems = [];
              for (var i = 0; i < 3; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              singleItems = [];
              for (var i = 3; i < 5; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              break;
            case 6:
              var singleItems = [];
              for (var i = 0; i < 3; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              singleItems = [];
              for (var i = 3; i < 6; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              break;
            default:
              self.actGroupIndexList = items;
              break;
          }
        } else {
          // グループありの場合
          if (self.pathstep.layoutID == 30) {
            self.actGroupIndexList = [[], []];
            for (var i = 0; i < items.length; i++) {
              for (var j = 0; j < items[i].length; j++) {
                if (i == 0) {
                  self.actGroupIndexList[0].push(items[i][j]);
                } else {
                  self.actGroupIndexList[1].push(items[i][j]);
                }
              }
            }
          } else {
            self.actGroupIndexList = items;
          }
        }
        resolve();
      });
    },
    /**
    /* 初期表示時の画像選択時のカーソルタイプを設定する
     */
    setCursorTypes: function() {
      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.isChallenge(this.pathstep.acts[i])) {
          // challengeの場合は、カーソルを矢印マークにする
          this.cursorTypes.push(constants.CURSOR_DEFAULT);
        } else {
          // givenの場合は、カーソルを指マークにする
          this.cursorTypes.push(constants.CURSOR_POINTER);
        }
      }
    },
    /**
     * オブジェクトのサイズを取得する
     */
    getObjectSize: function(obj) {
      var objSize = obj.length;
      if (objSize === undefined) {
        objSize = 1;
      }
      return objSize;
    },
    /**
     * 出題対象のactにスライダー遷移する
     */
    sliderToQuestionAct: function() {
      this.log("A1Q start sliderToQuestionAct");

      const self = this;

      return new Promise(function(resolve, reject) {
        if (self.isEnvironmentPc()) {
          resolve();
        }

        var swiperInSize = self.getObjectSize(self.swiperIn);
        var targetNum = self.isActive.length - 1;

        if (swiperInSize === 1) {
          self.swiperIn.slideTo(targetNum);
        } else {
          var off = 0;

          while (off < swiperInSize && self.getObjectSize(self.actGroupIndexList[off]) <= targetNum) {
            targetNum -= self.getObjectSize(self.actGroupIndexList[off]);
            off++;
          }

          self.swiperOut.slideTo(off);
          self.swiperIn[off].slideTo(targetNum);
        }
        self.setInterval(constants.QUESTION_INTERVAL).then(function() {
          resolve();
        });
      });
    },
    /**
     * 問題の出題処理
     */
    question: function() {
      this.log("A1Q start question");

      const self = this;
      this.isRestart = false;

      this.currentData = this.getQuestion(this.currentIndex);

      // スコア表示中は問題出題しない
      if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        return;
      }

      if (this.currentIndex.indexOf(Math.max.apply(null, this.currentIndex)) == -1) {
        // currentIndexが初期状態（何も値が設定されていない）の場合
        this.currentIndex.push(0);
      } else {
        // currentIndexの最大値 +1 をpushする
        this.currentIndex.push(this.currentIndex[this.currentIndex.indexOf(Math.max.apply(null, this.currentIndex))] + 1);
      }

      var actIndex = this.currentIndex.indexOf(Math.max.apply(null, this.currentIndex));

      this.isActive = [];
      this.isActive[actIndex] = true;

      // 問題取得できない場合は、次のpathstepへ遷移する
      if (this.currentData == null) {
        // 音声再生ボタンを有効にする
        var iconVoice = $(".icon-voice");
        iconVoice.removeClass("disabled");
        $(iconVoice).prop("disabled", false);

        // 親(Runmode.Vue）に通知する
        this.allCorrectTimer = setTimeout(function() {
          self.$emit("endAct");
        }, constants.ALLCORRECT_INTERVAL);
        return;
      }

      if (this.isChallenge(this.currentData)) {
        // challengeの場合は、解答文テキスト取得し、表示する
        this.setAnswerTarget();
        this.answersList = this.getAnswers(this.currentData.basicText);
        this.setAnswersTextList(constants.BASIC_TEXT);
        this.showSelectAnswer = true;
      } else {
        // givenの場合は、問題音声を再生し、次の問題を取得する
        this.sliderToQuestionAct().then(function() {
          self.showSelectAnswer = false;
          self.audioPlay(self.currentData.sounds[0]);
          self.isAudioPlaying = true;
          self.myAudio.onended = function() {
            self.setInterval(constants.QUESTION_INTERVAL).then(function() {
              self.question();
            });
          };
        });
      }
    },
    /**
     * 解答用テキストの設定
     *
     * @param textLanguage （/src/mixin/constants.jsの表示するテキスト言語を設定する）
     */
    setAnswersTextList: function(textLanguage) {
      this.log("A1Q start setanswersTextList");

      this.answersTextList = [];

      switch (textLanguage) {
        case constants.BASIC_TEXT:
          for (var i = 0; i < this.answersList.length; i++) {
            this.answersTextList.push(this.answersList[i].basicText);
          }
          break;
        case constants.JAPANESE_TEXT:
          for (var i = 0; i < this.answersList.length; i++) {
            this.answersTextList.push(this.answersList[i].japaneseText);
          }
          break;
        default:
          break;
      }
    },
    /**
     *  解答用テキスト押下処理
     */
    clickAnswer: function(answer, index) {
      this.log("A1Q start clickAnswer");

      const self = this;
      var actIndex = this.currentIndex.indexOf(Math.max.apply(null, this.currentIndex));

      if (answer == this.currentData.basicText) {
        // 正解の場合

        // correctIndexに追加していない場合は、追加する
        if (this.correctIndex.indexOf(actIndex) == -1) {
          this.correctIndex.push(actIndex);
        }

        // テキスト選択不可にする
        this.isSelect = false;

        // 正解時アニメーション対象を設定する
        this.setAniTarget(index).then(function() {
          // 正解時アニメーションを実行する
          self.isAnimate = true;
        });

        // 問題解答時の正解/不正解を設定する
        this.setActState(this.ActState);
        // ActStateの初期化
        this.ActState = true;

        // 正解音の再生
        this.audioCorrect();
        this.isAudioPlaying = false;

        // 正解画像の表示
        this.isCorrect = true;
        this.isInCorrect = false;
        this.showResult[actIndex] = true;
      } else {
        // 不正解の場合
        this.ActState = false;

        // 不正解音の再生
        this.audioInCorrect();
        this.isAudioPlaying = false;
        // 不正解画像の表示
        this.isCorrect = false;
        this.isInCorrect = true;
        this.showResult[actIndex] = true;

        this.setInterval(constants.INCORRECT_INTERVAL).then(function() {
          // 不正解画像を非表示に変更する
          self.isInCorrect = false;
          self.showResult[actIndex] = false;
        });
      }
    },
    /**
     *  出題文の日本語訳を英文に戻す
     */
    changeunDisp: function() {
      this.log("A1Q start changeunDisp");

      this.setAnswersTextList(constants.BASIC_TEXT);
    },
    /**
     *  出題文を日本語訳で表示する
     */
    changeDispJapanese: function() {
      this.log("A1Q start changeDispJapanese");

      this.setAnswersTextList(constants.JAPANESE_TEXT);
    },
    /**
     * 出題時アニメーション対象となるactを設定する
     */
    setAnswerTarget: function() {
      this.log("A1Q start setAnswerTarget");

      this.isAniTarget = [];
      this.isAnswerTarget = [];
      var actIndex = this.currentIndex.indexOf(Math.max.apply(null, this.currentIndex));

      this.isAnswerTarget[actIndex] = true;
    },
    /**
    /* 正解時アニメーション対象となるactを設定する
     */
    setAniTarget: function(index) {
      this.log("A1Q start setAniTarget");

      this.isAniTarget[index] = "aniTarget";

      return new Promise(function(resolve, reject) {
        resolve();
      });
    },
    /**
    /* actのanswerTarget設定後に実行するメソッド
     */
    childSetTarget: function() {
      this.log("A1Q start childSetTarget");

      const self = this;

      var iconVoice = $(".icon-voice");

      // 音声再生ボタンを有効にする
      iconVoice.removeClass("disabled");
      $(iconVoice).prop("disabled", false);

      this.isAnimate = false;
      // テキスト選択可能にする
      this.isSelect = true;

      // スライダーの移動
      if (!this.isEnvironmentPc()) {
        this.sliderToQuestionAct().then(function() {
          // スライダー実行後にアニメーション実行する
          self.setEleAni();
        });
      } else {
        this.setEleAni();
      }
    },
    /**
    /* 正解時アニメーション終了後に実行するメソッド
     */
    animateEnd: function() {
      this.log("A1Q start animateEnd");

      const self = this;
      var actIndex = this.currentIndex.indexOf(Math.max.apply(null, this.currentIndex));

      this.setInterval(constants.QUESTION_INTERVAL).then(function() {
        // スコア表示中は次の問題出題しない
        if (self.lessonState == storeConstants.LESSON_STATE_PAUSE) {
          self.isCorrect = false;
          self.showResult[actIndex] = false;
          self.showText[actIndex] = true;
          return;
        }
        self.audioPlay(self.currentData.sounds[0]);
        self.isCorrect = false;
        self.showResult[actIndex] = false;
        self.showText[actIndex] = true;

        // カーソルタイプをpointer（指マーク）に変更する
        self.cursorTypes[actIndex] = constants.CURSOR_POINTER;

        if (self.currentIndex.length == self.pathstep.acts.length) {
          // 全ての問題（givenを含めて全て）を出題した場合は、解答用テキストを非表示にする
          self.isActive = [];

          // 音声再生終了後、親(Runmode.Vue)に通知する
          self.myAudio.onended = function() {
            self.isAudioPlaying = false;
            self.allCorrectTimer = setTimeout(function() {
              self.$emit("endAct");
            }, constants.ALLCORRECT_INTERVAL);
          };
        } else {
          // 全ての問題（givenを含めて全て）を出題していない場合は、音声再生終了後、次の問題へ

          self.myAudio.onended = function() {
            self.isAudioPlaying = false;
            self.setInterval(constants.QUESTION_INTERVAL).then(function() {
              self.question();
              // pタグのidを削除する
              $("p").removeAttr("id");
              // テキストのidを削除する
              $(".input").removeAttr("id");
              //clone要素を削除
              $("#cloneAniTarget").remove();
            });
          };
        }
      });
    },
    /**
    /* 対象の解答項目の位置をアニメーション開始位置まで移動する
     */
    setEleAni: function() {
      this.log("A1Q start setEleAni");

      // 移動先の情報を取得
      let eleD = $("#answerTarget");
      let eleS1 = $(".toparea-play .eleAni");
      let eleS2 = $(".toparea-play .eleAni .input");
      let iconVoice = $(".toparea-play .icon-voice");

      eleS1.css("opacity", "1");

      let offsetTop = eleD.offset().top;
      let offsetLeft = eleD.offset().left;
      let eleWidth = eleD.outerWidth();
      let eleHeight = eleD.outerHeight();

      // 選択肢非表示解除
      eleS1.removeClass("hide");

      // 選択肢の位置を取得
      let offsetTopD = eleS1.offset().top;
      let offsetLeftD = eleS1.offset().left;

      // 音声アイコン非表示
      iconVoice.addClass("hide");

      if (this.isEnvironmentPc()) {
        // アニメーション開始 PC
        // 選択肢部分のスタイルを移動用に変更
        eleS1.css({
          position: "absolute",
          top: offsetTop - 45,
          left: offsetLeft,
          width: eleWidth,
          height: eleHeight,
          zIndex: 2
        });
        eleS2.css({
          position: "absolute",
          width: eleWidth,
          height: eleHeight,
          left: 0
        });

        // 移動
        eleS1.stop().animate({
          top: offsetTopD - 45,
          left: "39%",
          height: "70"
        }, 500, function() {
          eleS1.css({
            position: "relative",
            top: 0
          });
          eleS2.css({
            position: "relative",
            width: "250px",
            height: "70px"
          });
          iconVoice.removeClass("hide");
          eleS1.stop().animate({
            left: "0",
            width: "100%"
          }, 100);
        });
      } else {
        const self = this;
        // アニメーション開始 SP
        // 選択肢をカードのテキスト表示領域付近に配置
        eleS1.css({
          position: "absolute",
          top: offsetTop - $(".header").outerHeight(),
          left: offsetLeft,
          width: eleWidth,
          height: eleHeight,
          zIndex: 2
        });
        // 各選択肢をまとめる
        eleS2.css({
          position: "absolute",
          width: eleWidth,
          height: eleHeight,
          left: 0
        });
        // 出題文表示領域へ移動
        eleS1.stop().animate({
          top: "80%",
          left: "40%"
        }, 500, function() {
          // 出題文表示領域における選択肢の配置調整
          eleS1.css({
            position: "relative",
            top: 0
          });
          // 各選択肢を調整
          eleS2.css("cssText", "position: relative;");
          // 音声再生アイコン表示
          iconVoice.removeClass("hide");
          // 選択肢展開
          eleS1.stop().animate({
            left: 0,
            width: "96%",
            height: "100%"
          }, 100, function() {
            // 表示領域自動調整
            self.autoAdjustTopArea();
            self.applyTopAreaSize();
            // スクロールアイコン表示
            self.$emit("showScrollIcon", document.getElementsByClassName("eleAni")[0]);
          });
        });
      }
    },
    /**
     * 出題文領域自動サイズ調整処理
     */
    autoAdjustTopArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      const AUTO_ADJUST_MAX_FONT_SIZE = constants.AUTO_ADJUST_FONT_SIZE[this.textSize].max;

      // テキスト設定
      const setText = function(topAreaInput, topAreaText, targetText) {
        topAreaInput.children("span").css({ fontSize: AUTO_ADJUST_MAX_FONT_SIZE });
        topAreaText.html(targetText);
      };

      // 出題文領域の高さとフォントサイズを求める
      this.usTopAreaFontSize = AUTO_ADJUST_MAX_FONT_SIZE;
      this.jpTopAreaFontSize = AUTO_ADJUST_MAX_FONT_SIZE;
      let topAreaItems = $(".toparea-play > .eleAni > .item");
      for (let i = 0; i < topAreaItems.length; i++) {
        // 一時的にテキスト非表示
        let topAreaInput = $(topAreaItems.get(i)).children(".input");
        let topAreaText = topAreaInput.children("span");
        topAreaText.css("visibility", "hidden");

        let target = this.answersList[i];

        // 英語で実施
        setText(topAreaInput, topAreaText, target.basicText);
        this.usTopAreaFontSize = this.getAutoAdjustFontSize(topAreaInput, topAreaText, this.usTopAreaFontSize);
        // 日本語で実施
        setText(topAreaInput, topAreaText, target.japaneseText);
        this.jpTopAreaFontSize = this.getAutoAdjustFontSize(topAreaInput, topAreaText, this.jpTopAreaFontSize);

        // 英語表示に戻す
        topAreaText.html(target.basicText);
        topAreaText.css("visibility", "visible");
      }
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > .swiper-container:first > .swiper-wrapper:first > .item:first").clone();
        clones.textArea = clones.card.children("div").children("p");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > .swiper-container:first > .swiper-wrapper:first");
      };

      // サイズを確定させる
      this.fixCardAreaSize(cloneCard, clones);
    },
    /**
     * 出題文領域サイズ適用
     */
    applyTopAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // サイズ取得
      let fixedSize = this.getAutoAdjustFixedSize();
      let fixedFontSize = fixedSize.topAreaFontSize;
      // 確定したフォントサイズを設定
      let topAreaItems = $(".toparea-play > .eleAni > .item");
      topAreaItems.children(".input").children("span").css({ fontSize: fixedFontSize });
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // サイズ取得
      let fixedSize = this.getAutoAdjustFixedSize();
      let fixedHeight = fixedSize.cardAreaHeight;
      let fixedFontSize = fixedSize.cardAreaFontSize;

      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .swiper-container > .swiper-wrapper > .item > div > p");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });

      // 出題文表示領域の高さを調整する
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      $(".toparea-play").css({
        height: rootHeight - headerHeight - footerHeight - cardsContainerHeight
      });
    },
    /**
     * 自動調整サイズ適用
     */
    applyAutoAdjustSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      this.applyTopAreaSize();
      this.applyCardAreaSize();
    },
    /**
     * 長押しイベント開始
     *
     * @param String imgpath 画像パス
     */
    onTouchStart: function(imgpath) {
      this.log("A1Q start TouchEvent::" + imgpath);
      if (this.isEnvironmentPc()) {
        // PCの場合は表示しない
        return;
      }
      var self = this;

      this.touchTimer = setTimeout(function() {
        self.showPinchInImage(imgpath);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      this.log("A1Q end TouchEvent");
      clearTimeout(this.touchTimer);
    }
  },
  mounted: function() {
    this.init();

    if (this.lessonState == storeConstants.LESSON_STATE_START) {
      // 問題文の取得
      this.question();
    }

    // 自動調整初期処理
    this.initAutoAdjust([".page-content"], [".page-content"]);
  },
  watch: {
    /**
     * ツールバー「日本語翻訳を表示する」の選択状態を監視する
     */
    dispJapaneseStatus: function(newstatus) {
      this.log("A1Q watch dispJapaneseStatus");

      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.applyAutoAdjustSize();
          this.changeunDisp();
          this.isSelect = true;
        }
      } else {
        this.applyAutoAdjustSize();
        this.changeDispJapanese();
        this.isSelect = false;
      }
    },

    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A1Q watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.applyAutoAdjustSize();
          this.isSelect = true;
        }
      } else {
        this.applyAutoAdjustSize();
        this.changeunDisp();
        this.isSelect = false;
      }
    },
    /**
    /* 音声再生状態を監視する
     */
    isAudioPlaying: function(newstatus) {
      this.log("A1Q watch isAudioPlaying");

      var iconVoice = $(".icon-voice");

      if (this.isAudioPlaying) {
        // 音声再生ボタンを無効にする
        iconVoice.addClass("disabled");
        $(iconVoice).prop("disabled", true);
      } else {
        // 音声再生ボタンを有効にする
        iconVoice.removeClass("disabled");
        $(iconVoice).prop("disabled", false);
      }
    },
    /**
     * スコア表示状態を監視する
     */
    lessonState: function(newstatus) {
      this.log("A1Q watch lessonState");

      // currentIndexとcorrectIndexの最大値を取得する。
      var maxCurrentIndex = Math.max.apply(null, this.currentIndex);
      var maxCorrectIndex = Math.max.apply(null, this.correctIndex);

      if (this.lessonState == storeConstants.LESSON_STATE_START) {
        // 問題文の取得
        this.question();
      } else if (this.lessonState == storeConstants.LESSON_STATE_STOP) {
        this.$emit("stopAct");
      } else if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
        if (!this.dispJapaneseStatus && !this.dispAllAnswerStatus) {
          if (maxCurrentIndex != maxCorrectIndex) {
            this.currentIndex.pop();
            this.isRestart = true;
          }
        }
      } else if (this.lessonState == storeConstants.LESSON_STATE_RESTART) {
        if (!this.dispJapaneseStatus && !this.dispAllAnswerStatus) {
          if (!this.isRestart) {
            // pタグのidを削除する
            $("p").removeAttr("id");
            // テキストのidを削除する
            $(".input").removeAttr("id");
          }
          this.question();

          // 全問正解の場合は、アニメーション実行しない
          if (!this.isAllCorrect(this.correctIndex.length)) {
            this.setEleAni();
          }
        }
      }

      // 表示領域自動調整
      let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// A1Q.vue?f5fe4274